export const ERRORS = {
  CONVERSATION_ASSIST_ALREADY_STARTED:
    'conversation_assist.status.already_started',
  AUTH_REQUIRED: 'auth.required',
};
